
import React, { ReactNode } from "react";
import { motion } from "framer-motion";
import Layout from "../Layout";
import Header from "../Header";
import PageTransition from "../PageTransition";

interface DashboardLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  title,
  description
}) => {
  return (
    <Layout>
      <PageTransition>
        <Header />

        <motion.div 
          className="space-y-6 p-4 max-w-7xl mx-auto" 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
              <p className="text-muted-foreground mt-1">{description}</p>
            </div>
          </div>
          
          {children}
        </motion.div>
      </PageTransition>
    </Layout>
  );
};

export default DashboardLayout;
